import { Navigate, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/app/hooks/useAuth";
import { getProductsConfig } from "@/app/services/configService/getProductsConfig";
import { UserRoleEnum } from "@/app/services/usersService/user";
import { PartnerType } from "@/app/utils/partners.enum";
import { TriStateEnum } from "@/app/entities/TriState";

interface PartnerGuardProps {
  partner: PartnerType;
}

export function PartnerGuard({ partner }: PartnerGuardProps) {
  const { user } = useAuth();
  const { data: productsConfig, isLoading } = useQuery({
    queryKey: ["productsConfig"],
    queryFn: getProductsConfig,
  });
  if (isLoading) return null;

  const isEnabled = productsConfig?.products?.[partner]?.state !== TriStateEnum.OFF;

  if (isEnabled) return <Outlet />;

  if (!user?.role) return <Navigate to="/" replace />;

  return (
    <Navigate
      to={
        [UserRoleEnum.SUPPORT].includes(user.secondRole)
          ? "/support"
          : "/transacoes"
      }
      replace
    />
  );
}
